import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';

/**
 * DAO для работы с ченджлогами (изменениями сущностей).
 * Имена параметров соответствуют ChangelogsController::getListAction.
 */
class ChangelogsDAO {

	/**
	 * Загружает список записей ченджлога
	 */
	static async getList(
		filters?: {
			authorId?:       number;
			partnerId?:      number;
			entityTypeName?: string;
			entityPattern?:  string;
			eventTypeName?:  string;
			eventTime?:      { dateFrom: unknown; dateTo: unknown };
			changes?:        string;
		},
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'changelogs.getList',
			filters,
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}
}

export default ChangelogsDAO;
